/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectPerRatingResponse
 */
export interface ProjectPerRatingResponse {
    /**
     * 
     * @type {number}
     * @memberof ProjectPerRatingResponse
     */
    rating: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectPerRatingResponse
     */
    projectCount: number;
}

/**
 * Check if a given object implements the ProjectPerRatingResponse interface.
 */
export function instanceOfProjectPerRatingResponse(value: object): value is ProjectPerRatingResponse {
    if (!('rating' in value) || value['rating'] === undefined) return false;
    if (!('projectCount' in value) || value['projectCount'] === undefined) return false;
    return true;
}

export function ProjectPerRatingResponseFromJSON(json: any): ProjectPerRatingResponse {
    return ProjectPerRatingResponseFromJSONTyped(json, false);
}

export function ProjectPerRatingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPerRatingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rating': json['rating'],
        'projectCount': json['projectCount'],
    };
}

export function ProjectPerRatingResponseToJSON(value?: ProjectPerRatingResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rating': value['rating'],
        'projectCount': value['projectCount'],
    };
}

